import React from 'react';
import { IQuestion, IQuestionAnswer } from '@/components/staffer/Grading/types';
import { showsScoreInput } from '@/components/staffer/Grading/utils';
import ScoreEdit from '@/components/staffer/Grading/ScoreEdit';
import Comment from '@/components/shared/Grading/QuestionAnswerComment/Comment';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import useDisplayedSuggestion from '@/components/staffer/Grading/AISuggestion/useDisplayedSuggestion';

interface TeacherCommentAndScoreProps {
  question: IQuestion;
  questionAnswer?: IQuestionAnswer;
  studentId?: number;
}

const TeacherCommentAndScore = ({ question, questionAnswer, studentId }: TeacherCommentAndScoreProps) => {
  const {
    assignment,
    isAssessment,
    isTeacher,
    programId,
    student,
    submissionForStudent,
  } = useGradingStore();
  const submission = submissionForStudent(studentId);
  const aiSuggestion = useDisplayedSuggestion(questionAnswer);

  const currentStudentId = studentId || student?.id;
  const keyData = `${questionAnswer?.id}-${question.id}-${currentStudentId}`;
  // AIDEV-NOTE: deliberately excludes questionAnswer.id — grading a question the student never
  // answered creates the answer row, and keying on the new id remounts ScoreEdit mid-save, wiping
  // its "Saved at" status. ScoreEdit resets itself on question/student change instead.
  const scoreEditKey = `score-edit-${question.id}-${currentStudentId}`;
  const { teacher_comment: teacherComment, teacher_stamp: teacherStamp } = questionAnswer || {};

  const showTitle = isTeacher || questionAnswer?.teacher_comment || questionAnswer?.teacher_stamp;

  return (
    <div className="commentGradeContainer tw-flex tw-justify-between">
      {questionAnswer && (
        <div className="tw-py-4 tw-flex tw-flex-col tw-justify-start tw-w-full tw-items-start">
          {showTitle && <strong className="tw-py-2">Teacher&apos;s Comments:</strong>}
          <Comment
            key={`teacher-comment-${keyData}-${teacherComment}-${teacherStamp}`}
            commentingTeacher={questionAnswer.commenting_teacher}
            exerciseId={question.id}
            isTeacher={isTeacher}
            lastUpdated={questionAnswer.comment_updated_at}
            programId={programId}
            questionAnswerId={questionAnswer.id}
            teacherComment={teacherComment}
            teacherStamp={teacherStamp}
            textAreaId={`text-area-${keyData}`}
          />
        </div>
      )}
      {showsScoreInput(assignment, question) && (
        <ScoreEdit
          key={scoreEditKey}
          aiSuggestion={isTeacher ? aiSuggestion : undefined}
          isUnsubmittedAssessment={isAssessment() && submission?.submitted_at == null}
          question={question}
          questionAnswer={questionAnswer}
          studentId={currentStudentId}
        />
      )}
    </div>
  );
};

export default TeacherCommentAndScore;
